import { getAPI, postAPI, putAPI } from "../../../api/Networking";
import { PaginatedAPIResponse } from "../../../models/NetworkResponse";
import { UrgentSourcingRaisedRequestFilters } from "../../../models/UrgentSourcing/UrgentSourcingRequestFilter";
import { UrgentSourcingProductFilters } from "../../../models/UrgentSourcing/UrgentSourcingProductFilter";
import {
  UrgentSourcingAddProductForm,
  UrgentSourcingCatalogProductForm,
  UrgentSourcingRaisedRequestForm,
  UrgentSourcingProductDetails,
  UrgentSourcingRaisedRequestDetails,
  UrgentSourcingCategory,
} from "../../../models/UrgentSourcing/UrgentSourcing";

export default class UrgentSourcingAPI {
  getUrgentSourcingRequestListing = async (
    filters: UrgentSourcingRaisedRequestFilters
  ): Promise<PaginatedAPIResponse<UrgentSourcingRaisedRequestDetails>> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.page_no !== undefined)
        queryParams.append("page_no", filters.page_no.toString());

      if (filters.limit !== undefined)
        queryParams.append("limit", filters.limit.toString());

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text);

      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);

      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

      if (filters.raised_by)
        queryParams.append(
          "raised_by",
          filters.raised_by.map((item) => item.id).join(",")
        );
      if (filters.catalog_creator)
        queryParams.append(
          "catalog_creator",
          filters.catalog_creator.map((item) => item.id).join(",")
        );
      if (filters.product_created_by)
        queryParams.append(
          "product_created_by",
          filters.product_created_by.map((item) => item.id).join(",")
        );

      if (filters.status)
        queryParams.append(
          "status",
          filters.status.map((item) => item.id).join(",")
        );

      const response = await getAPI(
        `/v5/urgent-sourcing-requests?${queryParams.toString()}`
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  raisedRequest = async (data: UrgentSourcingRaisedRequestForm) => {
    try {
      const response = await postAPI(`/v5/urgent-sourcing-requests`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  approveRequest = async (addProductFormData: UrgentSourcingAddProductForm) => {
    try {
      const response = await postAPI(
        `/v5/urgent-sourcing-requests/urgent-sourcing-product`,
        addProductFormData
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  cancelRequest = async (id: number, cancelReason: string) => {
    try {
      const response = await putAPI(
        `/v5/urgent-sourcing-requests/request_id/${id}/cancel`,
        {
          cancelReason: cancelReason,
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  addCategory = async (categoryName: string) => {
    try {
      const response = await postAPI(`/admin/productCatalog/addCategory`, {
        categoryName,
      });
      return response;
    } catch (error) {
      throw error;
    }
  };

  getUrgentSourcingCategories = async (): Promise<UrgentSourcingCategory[]> => {
    try {
      const response = await getAPI(`/admin/productCatalog/allCategories`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getUrgentSourcingCategoriesList = async (): Promise<
    UrgentSourcingCategory[]
  > => {
    try {
      const response = await getAPI(`/admin/products/getCategories`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getUrgentSourcingProductsListing = async (
    filters: UrgentSourcingProductFilters
  ): Promise<PaginatedAPIResponse<UrgentSourcingProductDetails>> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.page_no !== undefined)
        queryParams.append("page_no", filters.page_no.toString());

      if (filters.limit !== undefined)
        queryParams.append("limit", filters.limit.toString());

      if (filters.search_text)
        queryParams.append("search_text", filters.search_text);

      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);

      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

      if (filters.added_by && filters.added_by.length > 0)
        queryParams.append(
          "added_by",
          filters.added_by.map((item) => item.id).join(",")
        );

      if (filters.product_created !== undefined)
        queryParams.append(
          "product_created",
          filters.product_created.toString()
        );

      const response = await getAPI(
        `/v5/urgent-sourcing-requests/products?${queryParams.toString()}`
      );

      return response.result;
    } catch (error) {
      throw error;
    }
  };

  addCatalogProduct = async (data: UrgentSourcingCatalogProductForm) => {
    try {
      const response = await postAPI(
        `/v5/urgent-sourcing-requests/products/catalogue_id/${data.catalogueId}/add`,
        data
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
